import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { Entities } from 'src/app/core/models/globals';
import { NavigationService } from 'src/app/core/services/navigation.service';

@Component({
  selector: 'app-license-server-left-panel',
  templateUrl: './license-server-left-panel.component.html',
  styleUrls: ['./license-server-left-panel.component.scss']
})
export class LicenseServerLeftPanelComponent implements OnInit {
  
  properties = [
    {
      name: 'Licenses',
      routerLink: 'licenses',
      spanClass: 'bi bi-file-text-fill',
    },
    {
      name: 'Logs',
      routerLink: 'logs',
      spanClass: 'bi bi-body-text',
    },
  ];

  selectedIndex: number;

  constructor(private navService: NavigationService, private router: Router, private route: ActivatedRoute) {}

  ngOnInit(): void {
    this.navService.index.subscribe(x => {
      this.selectedIndex = x;
    })
  }

  sendData(index: number, property) {
    if(this.selectedIndex != index ){
      this.selectedIndex = index;
      this.navService.sendParentData(property.name);
      this.navService.sendLeftPanelIndex(index);
      this.router.navigate([property.routerLink],{ relativeTo: this.route })
    }
    this.navService.selectedLogType = "License Server";
  }
}
